import DSFormControl from "../../system-design/DSFormControl";
import DSInputLabel from "../../system-design/DSInputLabel";
import DSSelect from "../../system-design/DSSelect";
import DSMenuItem from "../../system-design/DSMenuItem";
import { KlydoPickMethod } from "../../../api/calendarEvent";

interface KlydoPickMethodSelectProps {
  value: KlydoPickMethod | "";
  onChange: (value: KlydoPickMethod) => void;
}

function KlydoPickMethodSelect({
  value,
  onChange,
}: KlydoPickMethodSelectProps) {
  return (
    <DSFormControl fullWidth size="small" required error={!value}>
      <DSInputLabel>Klydo Pick Method</DSInputLabel>
      <DSSelect
        value={value}
        label="Klydo Pick Method"
        onChange={(changeEvent) =>
          onChange(changeEvent.target.value as KlydoPickMethod)
        }
      >
        <DSMenuItem value={KlydoPickMethod.RandomOne}>
          Random one — serve a single random klydo per day
        </DSMenuItem>
        <DSMenuItem value={KlydoPickMethod.All}>
          All — serve every assigned klydo
        </DSMenuItem>
      </DSSelect>
    </DSFormControl>
  );
}

export default KlydoPickMethodSelect;
